<div class="seccion-media">
  <h2>Autorxs</h2>
</div>
<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<div class="seccion-media">
  <div class="autores">
    <mat-card class="autor" *ngFor="let autor of autores">
      <a [routerLink]="['/autorxs/', autor._id]">
        <mat-card-title>{{ autor.nombre }}</mat-card-title>
      </a>
    </mat-card>
  </div>
</div>